export const CREATORS = [
  '_pira__',
  'koharubiyori_51',
  'sakiika10_game',
  'MHR_Qoo',
  'ibless0316',
  'MHR_Qoo_2',
  'MHR_Qoo_3',
] as const

export type CREATOR = (typeof CREATORS)[number]

export const creatorMapTargetId: Record<CREATOR, string> = {
  koharubiyori_51: 'splatoon3_1',
  sakiika10_game: 'splatoon3_2',
  MHR_Qoo: 'splatoon3_3',
  ibless0316: 'splatoon3_4',
  MHR_Qoo_2: 'splatoon3_5',
  _pira__: 'splatoon3_6',
  MHR_Qoo_3: 'splatoon3_7',
}

export const mapPSplatoon3CreatorInfo: Record<
  CREATOR,
  {
    profileCardImageURL: string
    creatorImageURL: string
  }
> = {
  _pira__: {
    profileCardImageURL: `/static/images/profiles/splatoon3_6/0.jpeg`,
    creatorImageURL: '',
  },
  sakiika10_game: {
    profileCardImageURL: `/static/images/profiles/splatoon3_2/0.jpeg`,
    creatorImageURL: '',
  },
  MHR_Qoo: {
    profileCardImageURL: `/static/images/profiles/splatoon3_3/0.jpeg`,
    creatorImageURL: '',
  },

  MHR_Qoo_2: {
    profileCardImageURL: `/static/images/profiles/splatoon3_5/0.jpeg`,
    creatorImageURL: '',
  },
  MHR_Qoo_3: {
    profileCardImageURL: `/static/images/profiles/splatoon3_7/0.jpeg`,
    creatorImageURL: '',
  },
  ibless0316: {
    profileCardImageURL: `/static/images/profiles/splatoon3_4/0-min.jpeg`,
    creatorImageURL: '',
  },
  koharubiyori_51: {
    profileCardImageURL: `/static/images/profiles/splatoon3_1/0.jpeg`,
    creatorImageURL: '',
  },
}
